"use client"
import Footer from '@/components/widgets/footer/Footer'
import SimpleComponent from '@/components/widgets/SimpleComponent'
import React from 'react'
import HeroSection from './customization-page-widgets/HeroSection'

const CustomizationPage = () => {
  return (
    <SimpleComponent>
        <HeroSection/>
        <Footer/>
    </SimpleComponent>
  )
}

export default CustomizationPage